// test688
(688 && 0);
